var _defs, _circle, _circle2, _circle3, _path, _path2, _path3, _tspan, _tspan2, _tspan3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabsharelogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-10.982 264.081 822.495 242.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        font-family: SFProRounded-Bold, 'SF Pro Rounded';\n        font-size: 133px;\n        font-weight: 700;\n      }\n\n      .cls-4 {\n        letter-spacing: 0em;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 102.36,
    cy: 435.47,
    r: 24.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 24.12,
    cy: 390.87,
    r: 24.12
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 102.36,
    cy: 345.05,
    r: 24.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m34.97,407.56s9.99,27.3,37.05,26.81l2.92,15.11s-38.51.24-53.38-37.78c.49.24,13.41-4.14,13.41-4.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m82.55,345.92s-28.63-5.01-41.75,18.65l-14.55-5.03s19.06-33.46,59.42-27.3c-.45.3-3.12,13.68-3.12,13.68Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m110.18,417.45s19.5-21.56,6.47-45.27l12.01-9.63s18.15,33.96-8.57,64.83c-.01-.54-9.91-9.93-9.91-9.93Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(221.24 429.68)",
    style: {
      whiteSpace: "pre"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "LabSha")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 458.94,
    y: 0
  }, "r")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 505.05,
    y: 0
  }, "e"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 177.34,
    y: 299.73,
    width: 2.56,
    height: 170.29,
    rx: 1.28,
    ry: 1.28
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabsharelogoWhite);
export default __webpack_public_path__ + "static/media/labsharelogo_white.7af94afa059db2ff18fa7ee2590e2cca.svg";
export { ForwardRef as ReactComponent };